import funcLazyDelayPage from "functions/funcLazyDelayPage";
import PageLoading from "pages/PageLoading";
import RevenuePlanPage from "pages/RevenuePlanPage";
import React, { lazy } from "react";
import {
	Route,
} from "use-react-router-breadcrumbs";
const DepartmentListPage = funcLazyDelayPage("DepartmentListPage");
const DashboardPage = funcLazyDelayPage('DashboardPage')
const LoginPage = funcLazyDelayPage('LoginPage')
const LayoutDashboard = lazy(() => import('../layouts/LayoutDashboard'))
const PageNotFound = funcLazyDelayPage("PageNotFound");
const PositionPage = funcLazyDelayPage("PositionPage");
const EmployeePage = funcLazyDelayPage("EmployeePage");
const EmployeeCreatePage = funcLazyDelayPage("EmployeeCreatePage");
const CompanyPage = funcLazyDelayPage("CompanyPage");
const CompanyCreatePage = funcLazyDelayPage("CompanyCreatePage");
const LeadPage = funcLazyDelayPage("LeadPage");
const LeadPageKanban = funcLazyDelayPage("LeadPageKanban");
const ProjectCreatePage = funcLazyDelayPage("ProjectCreatePage");
const LeadCreatePage = funcLazyDelayPage("LeadCreatePage");
const ContractPage = funcLazyDelayPage("ContractPage");
const ContractCreatePage = funcLazyDelayPage("ContractCreatePage");
const ProjectPage = funcLazyDelayPage("ProjectPage");
const ProjectPageKanban = funcLazyDelayPage("ProjectPageKanban");
const RevenuePlanDetail = funcLazyDelayPage("RevenuePlanDetail");
const ProfilePage = funcLazyDelayPage("ProfilePage");
const ProfilePageCreate = funcLazyDelayPage("ProfilePageCreate");
const EmployeeEditPage = funcLazyDelayPage("EmployeeEditPage");
const CompanyEditPage = funcLazyDelayPage("CompanyEditPage");
const LeadEditPage = funcLazyDelayPage("LeadEditPage");
const ContractEditPage = funcLazyDelayPage("ContractEditPage");
const ProjectEditPage = funcLazyDelayPage("ProjectEditPage");
const ProfileEditPage = funcLazyDelayPage("ProfileEditPage");

const GenerateAppRoutes = () => {
	return (
		<>
			<Route element={<LayoutDashboard></LayoutDashboard>}>
				<Route
					path='/'
					element={<DashboardPage></DashboardPage>}
					breadcrumb=''></Route>
				<Route
					path='Department'
					element={<DepartmentListPage></DepartmentListPage>}
					breadcrumb='Danh sách phòng ban'></Route>
				<Route
					path='Position'
					element={<PositionPage></PositionPage>}
					breadcrumb='Danh sách chức vụ'></Route>
				<Route
					path='Employee'
					element={<EmployeePage></EmployeePage>}
					breadcrumb='Danh sách nhân viên'></Route>
				<Route
					path='Employee/Create'
					element={<EmployeeCreatePage></EmployeeCreatePage>}
					breadcrumb='Tạo mới'></Route>
				<Route
					path='Employee/Edit'
					element={<EmployeeEditPage></EmployeeEditPage>}
					breadcrumb='Chỉnh sửa'></Route>
				<Route
					path='Company'
					element={<CompanyPage></CompanyPage>}
					breadcrumb='Danh sách khách hàng'></Route>
				<Route
					path='Company/Create'
					element={<CompanyCreatePage></CompanyCreatePage>}
					breadcrumb='Tạo mới'></Route>
				<Route
					path='Company/Edit'
					element={<CompanyEditPage></CompanyEditPage>}
					breadcrumb='Chỉnh sửa'></Route>
				<Route
					path='Lead'
					element={<LeadPage></LeadPage>}
					breadcrumb='Danh sách lead'></Route>
				<Route
					path='Lead/Kanban'
					element={<LeadPageKanban></LeadPageKanban>}
					breadcrumb='Danh sách Lead kanban'></Route>
				<Route
					path='Lead/Create'
					element={<LeadCreatePage></LeadCreatePage>}
					breadcrumb='Tạo mới'></Route>
				<Route
					path='Lead/Edit'
					element={<LeadEditPage></LeadEditPage>}
					breadcrumb='Chỉnh sửa'></Route>
				<Route
					path='Contract'
					element={<ContractPage></ContractPage>}
					breadcrumb='Danh sách hợp đồng'></Route>
				<Route
					path='Contract/Create'
					element={<ContractCreatePage></ContractCreatePage>}
					breadcrumb='Tạo mới'></Route>
				<Route
					path='Contract/Edit'
					element={<ContractEditPage></ContractEditPage>}
					breadcrumb='Chỉnh sửa'></Route>
				<Route
					path='Project'
					element={<ProjectPage></ProjectPage>}
					breadcrumb='Danh sách Project'></Route>
				<Route
					path='Project/Create'
					element={<ProjectCreatePage></ProjectCreatePage>}
					breadcrumb='Tạo mới Project'></Route>
				<Route
					path='Project/Edit'
					element={<ProjectEditPage></ProjectEditPage>}
					breadcrumb='Chỉnh sửa Project'></Route>
				<Route
					path='/revenue-plan'
					element={<RevenuePlanPage></RevenuePlanPage>}
					breadcrumb='Kế hoạch thu'></Route>
				<Route
					path='/revenue-plan/detail'
					element={<RevenuePlanDetail></RevenuePlanDetail>}
					breadcrumb='Kế hoạch thu chi tiết'></Route>
				<Route
					path='/Document'
					element={<ProfilePage></ProfilePage>}
					breadcrumb='Danh sách hồ sơ'></Route>
				<Route
					path='/Document/Create'
					element={<ProfilePageCreate></ProfilePageCreate>}
					breadcrumb='Tạo hồ sơ'></Route>
				<Route
					path='/Document/Edit'
					element={<ProfileEditPage></ProfileEditPage>}
					breadcrumb='Chỉnh sửa hồ sơ'></Route>
				<Route path='*' element={<PageNotFound></PageNotFound>}></Route>
			</Route>
			<Route
				path='/page-loading'
				element={<PageLoading></PageLoading>}></Route>
			<Route path='/login' element={<LoginPage></LoginPage>}></Route>
		</>
	);
};

export default GenerateAppRoutes;
